"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Textarea, Label } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsTextarea() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Textarea
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A multi-line text input for longer form content.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/textarea" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Basic textarea usage</CardDescription>
            </>
          }
          contentClassName="p-6 space-y-6"
        >
          <div className="space-y-2">
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" placeholder="Type your message here..." />
          </div>

          <div className="space-y-2">
            <Label htmlFor="bio">Bio</Label>
            <Textarea id="bio" placeholder="Tell us about yourself" rows={5} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="disabled">Disabled</Label>
            <Textarea id="disabled" placeholder="This is disabled" disabled />
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">placeholder</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Placeholder text</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">rows</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 text-muted-foreground">Number of visible text rows</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">disabled</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">boolean</td>
                <td className="py-2 text-muted-foreground">Disable the textarea</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
